import { postlabErrorCopy } from "@/lib/postlab/error-copy"

/** A machine slug ("quota_exceeded"), not a sentence written for people. */
const SLUG = /^[a-z][a-z0-9]*(?:_[a-z0-9]+)+$|^[a-z]+$/

export const QUERY_ERROR_FALLBACK =
  "Não foi possível carregar agora. Tente de novo."

/**
 * What the global query error toast says. A known PostLab slug gets its
 * pt-BR copy; any other slug gets a generic sentence, so a raw code never
 * reaches the screen; messages already written as sentences pass through.
 */
export function queryErrorToastMessage(error: Error): string {
  const message = error.message.trim()
  if (!message) return QUERY_ERROR_FALLBACK
  const copy = postlabErrorCopy(message)
  if (copy) return copy
  return SLUG.test(message) ? QUERY_ERROR_FALLBACK : message
}
